<style
  lang="less"
  scoped="">
  .relatePr {
    border: 1px solid #eaeaea;
    padding-bottom: 30px;
    margin-right: 20px;
    p {
      height: 47px;
      line-height: 47px;
      border-bottom: 1px solid #eaeaea;
      padding: 0 20px;
      color: #333333;
      background: #f9f9f9;
    }
    h2 {
      font-size: 14px;
      color: #333;
      font-weight: normal;
      padding: 0 20px;
      margin-top: 20px;
      overflow: hidden;
    }
    .h2_icon {
      margin-right: 18px;
      i{
        width: 16px;
        height: 16px;
        display: inline-block;
      }
    }
    li {
      color: #777;
      font-size: 12px;
      overflow: hidden;
      padding: 0 20px;
      margin-top: 20px;
      margin-left: 34px;
      a{
        color: #777;
        font-size: 12px;
      }
    }
    ul {
      transition: height .5s ease-in-out;
      &.active {
        height: 40px;
        overflow: hidden;
      }
    }
  }
</style>

<template>
  <div class="relatePr">
    <p>相关产品推荐</p>
    <ul v-for="(item,key,index) in relatedProducts"
        :class="{active: !actives[index]}">
      <h2 @click="toggle(index)" style="cursor: pointer">
        <span class="h2_icon">
          <i v-if="!actives[index]"><img src="//v3.cdn.qiyewan.com/jia.png" alt="add_icon"></i>
        <i v-else><img src="//v3.cdn.qiyewan.com/jian.png" alt="sub_icon"></i>
      </span>{{ key }}</h2>
      <li v-for="(p,p_index) in item">
        <router-link :to="{ name: 'product-detail', params: { serialId: p.serialId }}" param>{{ p.name }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        actives: [true, false, false]
      }
    },
    props: {
      code: String,
    },
    computed: {
      relatedProducts(){
        return this.$store.getters.relatedProducts(this.code) || []
      },
    },
    methods: {
      toggle(index) {
        this.$set(this.actives, index, !this.actives[index])
      },
    },
  }
</script>



// WEBPACK FOOTER //
// RelatedProducts.vue?2182fcb0